<!--
 * @description:首页关于我们 
 * @Author: Jay
 * @Date: 2021-09-22 17:58:48
 * @LastEditors: Jay
 * @LastEditTime: 2022-02-14 10:16:04
-->
<template>
  <div>
    <!-- 动画效果 -->
    <div v-class="'animate__animated animate__fadeInUp'">
      <div class="with-code flex">
        <!-- 大图 -->
        <el-image class="with-img" :src="$api + withData.image" fit="fit" />
        <!-- 左边内容 -->
        <div class="padding-left-xl padding-top-xxl">
          <h3 class="engTitle font_size_df text-black">
            {{ withData.title }}
          </h3>
          <h1 class="padding-top-xs font_size_xl text-black">
            {{ withData.name }}
          </h1>
          <div class="line margin-top-sm"></div>
          <!-- 内容介绍 -->
          <div class="margin-top-xs font_size_df txt-detail">
            <p v-html="withData.content"></p>
          </div>
          <!-- 查看更多 -->
          <div class="margin-top-xl">
            <router-link to="/AboutUs">
              <span class="text-paleblue"> 查看更多</span>
              <div class="line-more margin-top-xs"></div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "homeWith",
  props: ["withData"],
  data() {
    return {
      isFixed: false,
    };
  },
  mounted() {},
  methods: {},
  destroyed() {
    // console.log("组件销毁");
  },
};
</script>

<style lang="scss" scoped>
.with-code {
  //   border: 1px solid rgb(207, 207, 207);
  box-shadow: 1px 4px 20px 1px rgb(207, 207, 207);
  border-radius: 5px;
  // height: 440px;
  //图片
  .with-img {
    width: 670px;
    height: 100%;
    border-radius: 5px 0 0 5px;
  }
  //大写英文
  .engTitle {
    text-transform: uppercase;
  }

  // 虚线
  .line {
    width: 33px;
    height: 3px;
    background-color: #dfdfdf;
  }
  //   内容介绍
  .txt-detail {
    width: 498px;
    color: #666666;
    line-height: 32px;
    display: -webkit-box;
    display: -moz-box;
    overflow: hidden;
    text-overflow: ellipsis;
    // word-break: break-all;
    // -webkit-box-orient: vertical;
    // -webkit-line-clamp: 4;
  }

  //查看更多
  .line-more {
    width: 55px;
    height: 2px;
    background-color: #54bad4;
  }
  .line-more:hover {
    width: 11px;
    text-align: center;
    height: 2px;
    background-color: #54bad4;
  }
}
// .with-code:hover {
//   box-shadow: 1px 4px 20px 1px rgb(207, 207, 207);
// }
</style>
